module.exports = __webpack_public_path__ + "img/4_33.dc5b1299.png";